// 🔧 homepage_builder.js
// ✅ Purpose: Homepage Builder for the LGV Demo Engine
// ✅ Features:
// - Updates the demo event document with homepage content
// - Uses industry-specific homepage template
// - Keeps homepage generation separate from Event Builder
// - Future-ready for AI homepage generation
// - Fully block-commented for clarity and future devs

import {
  doc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";

import { db } from "../../firebase";
import { logger } from "../../utils/logger";

import { buildHomepageContent } from "../templates/homepage_defaults";

export const buildHomepage = async ({
  eventResult,
  industryTemplate,
} = {}) => {

  if (!eventResult?.eventId) {
    throw new Error(
      "Homepage Builder requires an event."
    );
  }

  const homepageContent =
    buildHomepageContent({
      eventName:
        eventResult.eventName,

      industryTemplate,
    });

  await updateDoc(
    doc(
      db,
      "events",
      eventResult.eventId
    ),
    {
      homepageContent,

      updatedAt:
        serverTimestamp(),
    }
  );

  logger.log(
    "🏠 Homepage Builder completed.",
    {
      value: {
        eventId:
          eventResult.eventId,
      },
    }
  );

  return {
    builder: "homepage_builder",

    ready: true,

    createdCount: 1,

    homepageContent,

    message:
      "Homepage content created.",
  };
};

export const buildHomepageShell =
async ({
  eventResult,
  industryTemplate,
} = {}) => {

  if (!eventResult?.eventId) {
    return {
      builder: "homepage_builder",

      ready: false,

      createdCount: 0,

      message:
        "Homepage Builder requires an event.",
    };
  }

  return buildHomepage({
    eventResult,
    industryTemplate,
  });
};